import React from 'react'
import TranslationCont from '../General/TranslationCont'
import isFskNotKnown from '../functions/isFskNotKnown'

const MovieFskAccess = ({fsk}) => (
    <>
        <dt><TranslationCont id="fsk" after=':'>FSK</TranslationCont> </dt>
        <dd>{isFskNotKnown(fsk) ? <TranslationCont id='FSKnotKnown'>FSK Unbekannt</TranslationCont> : fsk}</dd>
    </>
)

export default MovieFskAccess